export default function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_complement.js
// module id = 1122
// module chunks = 1